export default __webpack_public_path__ + "static/media/misc-drawerB-1440w.fe08dab7.png";